import { message, Modal, Spin } from "antd";
import { useEffect, useState } from "react";
import { useDisconnect } from "wagmi";
import { ethers } from "ethers";
import { useForm } from "react-hook-form";
import { apiLaunchPad } from "../../../api/apiLaunchPad";

const SubmitSolanaModal = ({
  modalOpen,
  setModalOpen,
  address,
  campaignId,
}: {
  modalOpen: boolean;
  setModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  address: string;
  campaignId: number;
}) => {
  const [loading, setLoading] = useState(false);
  const {
    handleSubmit,
    register,
    formState: { errors },
    reset,
  } = useForm<{ claim_address: string }>({
    mode: "onChange",
  });

  const { disconnect } = useDisconnect();
  const messageContent = "Welcome to TinyBlock!";

  const signMessage = async () => {
    try {
      if (!window?.ethereum) {
        message.error({
          type: "error",
          content: "Please install MetaMask",
          className: "custom-class",
          duration: 2,
        });
        return null;
      }

      const provider = new ethers.providers.Web3Provider(window.ethereum);
      await provider.send("eth_requestAccounts", []);
      const signer = provider.getSigner();

      try {
        const signature = await signer.signMessage(messageContent);
        return signature;
      } catch (error: any) {
        if (error?.code === 4001) {
          disconnect();
        } else {
          message.error({
            type: "error",
            content: "An error occurred",
            className: "custom-class",
            duration: 2,
          });
          disconnect();
        }
        return null;
      }
    } catch (error: any) {
      message.error({
        type: "error",
        content: "An error occurred",
        className: "custom-class",
        duration: 2,
      });
      return null;
    }
  };

  const handleSubmitSolanaAddress = async (data: { claim_address: string }) => {
    try {
      setLoading(true);
      const signature = await signMessage();
      const requestBody = {
        campaign_id: campaignId,
        commit_address: address,
        claim_address: data.claim_address,
        message: messageContent,
        signature: signature,
      };
      const response = await apiLaunchPad.submitSolanaAddres(requestBody);
      if (response.status === 201) window.location.reload();
    } catch (error) {
      message.error({
        type: "error",
        content: "An error occurred",
        className: "custom-class",
        duration: 2,
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!modalOpen) reset();
  }, [modalOpen, reset]);

  return (
    <Modal
      title={null}
      open={modalOpen}
      footer={null}
      onCancel={() => setModalOpen(false)}
      centered
      className="xl:min-w-[600px]"
    >
      <div className="xs:px-2 md:px-4 py-2">
        <div className="mt-2 font-Azonix text-[26px] xxs:text-3xl xs:text-4xl text-center">
          Solana address
        </div>
        <div className="mt-2 font-Montserrat text-lg text-center font-semibold text-gray-600">
          Link to EVM wallet
        </div>
        <form
          className="mt-3"
          onSubmit={handleSubmit(handleSubmitSolanaAddress)}
        >
          <input
            type="text"
            className="w-full border border-gray-200 rounded-md px-4 py-2 text-lg outline-none"
            {...register("claim_address", {
              required: "This field is required",
            })}
            placeholder="Enter your address"
          />
          {errors.claim_address && (
            <div className="mt-2 font-Montserrat text-red-600 text-sm font-normal">
              {errors.claim_address.message}
            </div>
          )}
          <div className="mt-4 flex justify-end">
            <button
              type="submit"
              className="min-w-32 rounded-lg bg-customBlue-500 text-white font-Montserrat text-xl leading-[1] px-5 py-2 uppercase"
            >
              {loading ? <Spin /> : "Submit"}
            </button>
          </div>
        </form>
      </div>
    </Modal>
  );
};

export default SubmitSolanaModal;
